export default __webpack_public_path__ + "static/player_photo_1-07a449a3ee61fef278cddd00dc30156e.mp4";